export default {
  GET_SELECT_SECRETARY:(state)=>{
      return state.selectSecretary
  },
  GET_RESULT:(state)=>{
      return state.Result
  },
  GET_EDIT_SECRETARY:(state)=>{
      return state.editSecretary
  },
}